import { render, staticRenderFns } from "./ScoutingScoreSelectorV3.vue?vue&type=template&id=008c8ebe&scoped=true&"
import script from "./ScoutingScoreSelectorV3.vue?vue&type=script&lang=ts&"
export * from "./ScoutingScoreSelectorV3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008c8ebe",
  null
  
)

export default component.exports